export default "__VITE_ASSET__Cx8VkG$Y__"